import React, { ComponentProps } from "react";

import { Button } from "@examspark/common-ui";
import { IconFeedbackLine } from "@examspark/common-ui/dist/components/icons";

import { useAuthorizationContext } from "../hooks/useAuthorizationContext";
import { useModal } from "../hooks/useModal";
import { useAppContext } from "../providers";

import FeedbackModal from "./FeedbackModal";

type Props = {
  showItemFeedbackHint?: boolean;
} & ComponentProps<typeof Button>;

const FeedbackButton = (props: Props) => {
  const modal = useModal();
  const authorizationContext = useAuthorizationContext();
  const { appId, workspaceId, userId } = authorizationContext;
  const [appContext] = useAppContext();
  const userEmail = appContext.user?.email;

  if (
    !appId ||
    !workspaceId ||
    !userId ||
    !appContext.app?.config?.feedbackOptions
  ) {
    return null;
  }

  const resolvedAuthContext = {
    appId,
    workspaceId,
    userId,
  };

  return (
    <>
      {authorizationContext.appId &&
        authorizationContext.workspaceId &&
        userEmail && (
          <>
            <Button
              title="Feedback"
              onClick={() => modal.open()}
              variant="outlined"
              {...props}
            >
              <IconFeedbackLine width="17" />
              Feedback
            </Button>
            <FeedbackModal
              userEmail={userEmail}
              appContext={appContext}
              resolvedAuthContext={resolvedAuthContext}
              showItemFeedbackHint={props.showItemFeedbackHint}
              options={appContext.app.config.feedbackOptions}
              {...modal.modalProps}
            />
          </>
        )}
    </>
  );
};

export default FeedbackButton;
